import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Switch from '../../../Part_Sample/Switch';
import Editbox from '../../../Part_Sample/Editbox';
import Button from '../../../Part_Sample/Button';
import { isEmpty } from '../../../Common/Common';

export default class Schedule_Office_Summary extends Component {
	constructor(props) {
		super(props);

		this.lastClickTime = false;

		if (this.props.param.program_id == null && this.props.param.program == null) {
			this.props.content_handler('Schedule_Step1_Name', { schedule: this.props.param.schedule, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups });
		}

		this.program = {};
		if (this.props.param.program != null) {
			this.program = this.props.param.program
		} else if (this.props.param.schedule.program[this.props.param.program_id] != null) {
			this.program = this.props.param.schedule.program[this.props.param.program_id];
		}

		if (this.program.target == null) {
			this.program.target = [];
		}
		if (this.program.action == null) {
			this.program.action = {};
		}

		let schedule_name = '';
		let is_enabled = false;

		if (this.program.name != null && this.program.name != undefined) schedule_name = this.program.name;
		if (this.program.exec != null) is_enabled = this.program.exec;

		let op_type = 'target';
		if (this.props.param.op_type != null) op_type = this.props.param.op_type;

		this.state = {
			op_type: op_type,
			is_enabled: is_enabled,
			schedule_name: schedule_name,
		}
	}

	preventMultipleTaps = () => {
		if (this.lastClickTime == false) {		//Check if it is first click, allow
			this.lastClickTime = true;
			return true;
		} else {
			return false;
		}
	}

	handleShowOps = (command) => {
		this.setState({
			op_type: command
		})
	}

	handlePrevious = () => {
		let param = this.props.param;
		this.program.name = this.state.schedule_name;
		this.program.exec = this.state.is_enabled;
		param.program = this.program;
		if (param.from == 'Schedule') {
			this.props.content_handler('Schedule', { schedule: this.props.param.schedule, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups });
		} else {
			this.props.content_handler('Schedule_Step3_Pattern', param);
		}
	}

	handleToggleEnable = () => {
		this.setState({ is_enabled: !this.state.is_enabled })
	}

	handleChangeScheduleName = (val) => {
		this.setState({ schedule_name: val })
	}

	handleEditScheduleTarget = () => {
		let param = this.props.param;
		this.program.name = this.state.schedule_name;
		this.program.exec = this.state.is_enabled;
		param.program = this.program;
		param.from = 'Schedule_Office_Summary';
		param.op_type = 'target';
		this.props.content_handler('Schedule_Step2_Target', param);
	}

	handleAddSchedulePatternRoutine = () => {
		let param = this.props.param;
		this.program.name = this.state.schedule_name;
		this.program.exec = this.state.is_enabled;
		param.program = this.program;
		param.pattern_id = '';
		param.original_pattern_id = '';
		param.from = 'Schedule_Office_Summary';
		param.op_type = 'pattern';
		this.props.content_handler('Schedule_Step3_Pattern', param);
	}

	handleEditSchedulePatternRoutine = (pattern_id) => {
		let param = this.props.param;
		this.program.name = this.state.schedule_name;
		this.program.exec = this.state.is_enabled;
		param.program = this.program;
		param.pattern_id = pattern_id;
		param.original_pattern_id = '';
		param.from = 'Schedule_Office_Summary';
		param.op_type = 'pattern';
		this.props.content_handler('Schedule_Step3_Pattern', param);
	}

	handleRegister = () => {
		if (!this.preventMultipleTaps()) return;
		window.app.showLoading();

		if (this.state.schedule_name == '') {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		} else if (this.program.target == null || this.program.target.length < 1) {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('no_target'), 3000);
			return;
		}

		this.program.name = this.state.schedule_name;
		this.program.exec = this.state.is_enabled;

		if (this.props.param.program_id == null) {
			this.props.receiver.addScheduleProgram(this.program);
		} else {
			let program = {};
			program[this.props.param.program_id] = this.program
			this.props.receiver.modifyScheduleProgram(program);
		}
	}

	handleDelete = () => {
		if (!this.preventMultipleTaps()) return;
		window.app.showLoading();

		this.props.receiver.deleteScheduleProgram(this.props.param.program_id);
	}

	rcvAddScheduleProgram(response) {
		if (response.result != 'NG') {
			this.props.receiver.next_component = 'Schedule';
			this.props.receiver.getScene();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvModifyScheduleProgram(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'Schedule';
			this.props.receiver.getScene();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvDeleteScheduleProgram(response) {
		if (response.result == 'OK') {
			this.props.receiver.next_component = 'Schedule';
			this.props.receiver.getScene();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
		}
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let button_style = {
			width: this.props.width - 60,
			padding: 20,
			backgroundColor: 'white',
			marginTop: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			borderRadius: 20,
		}

		let days_display = [this.props.receiver.getString('s_sun'), this.props.receiver.getString('s_mon'), this.props.receiver.getString('s_tue'), this.props.receiver.getString('s_wed'), this.props.receiver.getString('s_thu'), this.props.receiver.getString('s_fri'), this.props.receiver.getString('s_sat')]

		let max_height = this.props.height - 270;
		//if(max_height< 200) max_height = 200;

		// Tommy - 11/04/2021
		//Controller Options Validation
		let available_functions = this.props.receiver.active_controller.available_functions;

		//Alex - 18/10/21 - Added action check to see if ID exist in Device list/Schedule/Scenes/Interlock/Group, same as Interlock Summary
		for (let i = this.program.target.length; i >= 0; i--) {		//Loop will remove array, mess up length. Thats why reverse loop
			let sched_action = this.program.target[i];

			if (!isEmpty(sched_action)) {
				let existAsDevice = false;
				let existAsSchedule = false;
				let existAsScene = false;
				let existAsInterlock = false;
				let existAsGroup = false;

				if (window.app.state.point_list.hasOwnProperty(sched_action)) existAsDevice = true;

				if(available_functions.schedule) {
					if(this.props.param.schedule.hasOwnProperty('program')) {
						if (this.props.param.schedule.program.hasOwnProperty(sched_action)) existAsSchedule = true;
					}
				}

				if(available_functions.scene) {
					if (this.props.param.scenes.hasOwnProperty(sched_action)) existAsScene = true;
				}

				if(available_functions.interlock) {
					if(this.props.param.interlock.hasOwnProperty('program')) {
						if (this.props.param.interlock.program.hasOwnProperty(sched_action)) existAsInterlock = true;
					}
				}

				if(available_functions.group) {
					if (this.props.param.groups.hasOwnProperty(sched_action)) existAsGroup = true;
				}

				if (!existAsDevice && !existAsSchedule && !existAsScene && !existAsInterlock && !existAsGroup) {
					this.program.target.splice(i, 1);
				}
			} else {
				this.program.target.splice(i, 1);
			}
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('schedule_summary')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ height: 65 }}>
						<div style={{ display: 'inline-block', width: this.props.width - 100, marginLeft: 10 }}>
							<Editbox id='schedule_name' style={{}} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangeScheduleName(event.target.value)} value={this.state.schedule_name} />
						</div>
						<div style={{ display: 'inline-block', marginLeft: 10, marginRight: 10 }}>
							<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleEnable} />
						</div>
					</div>

					<div style={{ borderTop: '1px solid gray', borderBottom: '1px solid gray', marginTop: 20, verticalAlign: 'bottom' }}>
						<span style={{ cursor: 'pointer', display: 'inline-block', marginLeft: 0, width: '50%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.op_type == 'target' ? this.props.colours.midnight_sky : 'white', color: this.state.op_type == 'target' ? 'white' : 'black' }} onClick={() => this.handleShowOps('target')}>{this.props.receiver.getString('target')}</span>
						<span style={{ cursor: 'pointer', display: 'inline-block', marginLeft: 0, width: '50%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.op_type == 'pattern' ? this.props.colours.midnight_sky : 'white', color: this.state.op_type == 'pattern' ? 'white' : 'black' }} onClick={() => this.handleShowOps('pattern')}>{this.props.receiver.getString('routine')}</span>
					</div>
					{(() => {
						switch (this.state.op_type) {
							case 'target':
								return (
									<div className='noScrollBar' onClick={this.handleEditScheduleTarget} style={{ cursor: 'pointer', width: '100%', marginTop: 20, overflow: "auto", height: max_height }}>
										{this.program.target.map((target_id, i) => {
											let target_name = target_id;
											let show_target = true; //Tommy - 13/04/2021

											if (window.app.state.point_list[target_id] != null) {
												target_name = window.app.state.point_list[target_id].name;
											} else if (this.props.param.groups[target_id] != null) {
												target_name = this.props.receiver.getString(this.props.param.groups[target_id].name);
											} else if (this.props.param.scenes[target_id] != null) {
												target_name = this.props.param.scenes[target_id].name
												show_target = available_functions.scene;
											} else if (this.props.param.interlock.program != null) {
												if (this.props.param.interlock.program[target_id] != null) {
													target_name = this.props.param.interlock.program[target_id].name
													show_target = available_functions.interlock;
												}
											}

											// Tommy - 13/04/2021 - Added schedule name
											if (this.props.param.schedule.program != null) {
												if (this.props.param.schedule.program[target_id] != null) {
													target_name = this.props.param.schedule.program[target_id].name
													show_target = available_functions.schedule;
												}
											}

											if (show_target) {
												return (
													<div>
														<span>{target_name}</span>
													</div>
												)
											} else {
												return null;
											}

										})}
										<div id='add_target' style={{ width: '100%', minWidth: 30, verticalAlign: 'top', marginTop: 20, textAlign: 'center', cursor: 'pointer' }}>
											<span className='footnote'>{this.props.receiver.getString('edit_target_instr')}</span>
										</div>
									</div>
								);
								break;
							case 'pattern':
								return (
									<div className='noScrollBar' style={{ width: '100%', marginTop: 20, overflow: "auto", height: max_height }}>
										<div>
											{Object.keys(this.program.action).map((pattern_id) => {
												let program = this.program.action[pattern_id];
												let pattern = this.props.param.schedule.pattern[pattern_id];
												if (!isEmpty(pattern)) {
													let dow_string = '';

													if (program.exec_dow != null) {
														for (let i of program.exec_dow) {
															dow_string = dow_string + days_display[i] + ' ';
														}
													}

													let special_cal_string = '';
													if (program.exec_cal.length > 0) {
														for (let i of program.exec_cal) {
															let calendar = this.props.param.schedule.calendar[i];
															if (!isEmpty(calendar)) special_cal_string = special_cal_string + calendar.name + ', ';
														}
													}

													special_cal_string = (special_cal_string.trim()).replace(/,\s*$/, "");

													return (
														<div style={{ cursor: 'pointer', textAlign: 'left', marginTop: 20, marginLeft: 20 }} onClick={() => this.handleEditSchedulePatternRoutine(pattern_id)}>
															<div style={{ display: 'inline-block', width: this.props.width - 120, verticalAlign: 'top' }}>
																<span>{pattern.name}</span>
															</div>
															<div style={{ display: 'inline-block' }}>
																<div>
																	<span>{dow_string}</span>
																</div>
																<div>
																	<span>{special_cal_string}</span>
																</div>
															</div>
														</div>
													)
												}
											})}
										</div>
										<div id='add_pattern' onClick={this.handleAddSchedulePatternRoutine} style={{ padding: 5, width: this.props.width - 80, marginLeft: 'auto', marginRight: 'auto', minWidth: 30, verticalAlign: 'top', marginTop: 30, textAlign: 'center', cursor: 'pointer', border: '1px solid ' + this.props.colours.appBlue }}>
											<span className='footnote'>{this.props.receiver.getString('add_pattern_instr')}</span>
										</div>
									</div>
								);
								break;
							default:
								return (
									<div>

									</div>
								);
						}
					})()}
				</div>
			</div>
		)
	}
}